import {
  IDeviceSettingsPayload,
  IUpdateScreenTimePayload,
  IToggleDeviceStatusPayload,
} from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const updateDeviceSettings = async (payload: IDeviceSettingsPayload) => {
  return serviceHelper(
    http.patch('/school/controls/device-settings', payload),
    true
  );
};

export const getDeviceSettings = async () => {
  return serviceHelper(http.get('/school/controls/device-settings'), false);
};

export const getDeviceList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/school/controls/devices?${queryString}`),
    false
  );
};

export const getDeviceDetail = async (deviceId: string) => {
  return serviceHelper(http.get(`/school/controls/devices/${deviceId}`), false);
};

export const removeDevice = async (deviceId: string) => {
  return serviceHelper(
    http.delete(`/school/controls/devices/${deviceId}`),
    true
  );
};

//parent controls APIs
// ─── Parent Device Management APIs ──────────────────────────────────────────

export const getParentDevices = async (childId: string) => {
  return serviceHelper(http.get(`/parent/devices?child_id=${childId}`), false);
};

export const toggleParentDeviceStatus = async (
  payload: IToggleDeviceStatusPayload
) => {
  return serviceHelper(http.patch('/parent/devices/status', payload), true);
};

export const deleteParentDevice = async (deviceId: string) => {
  return serviceHelper(http.delete(`/parent/devices/${deviceId}`), true);
};

// ─── Parent Screen Time APIs ────────────────────────────────────────────────

export const getParentScreenTime = async (childId: string) => {
  return serviceHelper(http.get(`/parent/screen-time/${childId}`), false);
};

export const updateParentScreenTime = async (
  payload: IUpdateScreenTimePayload
) => {
  return serviceHelper(http.patch('/parent/screen-time', payload), true);
};

export const getParentScreenTimeGraph = async (
  childId: string,
  filter: number
) => {
  return serviceHelper(
    http.get(`/parent/child/${childId}/screen-time-graph?filter=${filter}`),
    false
  );
};
